import React from 'react';
import { LicensePlan } from '@/types/license';
import { FeatureGroups } from '@/utils/featureUtils';
import { FeatureGroup } from '../features/FeatureGroup';

interface MatrixBodyProps {
  featureGroups: FeatureGroups;
  plans: LicensePlan[];
}

export const MatrixBody: React.FC<MatrixBodyProps> = ({ featureGroups, plans }) => {
  return (
    <>
      {Object.entries(featureGroups).map(([groupName, features]) => (
        features.length > 0 && (
          <FeatureGroup
            key={groupName}
            groupName={groupName}
            features={features}
            plans={plans}
          />
        )
      ))}
    </>
  );
};